import { QuestionTicket } from 'components/QuestionTicket/QuestionTicket';

export const QuestionPage = () => {
  return (
    <>
      <QuestionTicket />
    </>
  );
};
